/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { Component } from 'react'

const defaultMapScale = () => {
    return 2
}

// const values = (obj) => {
//     // eslint-disable-next-line @typescript-eslint/no-unsafe-return
//     return Object.keys(obj).map((key) => obj[key])
// }

const IMAGE_FORMATS = {
    //png8 or png (default) specifies the 8-bit PNG format.
    PNG: 'png',

    //png32 specifies the 32-bit PNG format.
    PNG32: 'png32',

    //gif specifies the GIF format.
    GIF: 'gif',

    //jpg specifies the JPEG compression format.
    JPG: 'jpg',

    //jpg-baseline specifies a non-progressive JPEG compression format.
    JPG_BASELINE: 'jpg-baseline'
}

const MAP_TYPES = {
    //roadmap (default) specifies a standard roadmap image, as is normally shown on the Google Maps website.
    ROADMAP: 'roadmap',

    //satellite specifies a satellite image.
    SATELLITE: 'satellite',

    //terrain specifies a physical relief map image, showing terrain and vegetation.
    TERRAIN: 'terrain',

    //hybrid specifies a hybrid of the satellite and roadmap image,
    // showing a transparent layer of major streets and place names on the satellite image.
    HYBRID: 'hybrid'
}

// const IMAGE_FORMATS_VALUES = values(IMAGE_FORMATS)
// const MAP_TYPES_VALUES = values(MAP_TYPES)

// the Image's source should be ignored
// const { source, ...imagePropTypes } = Image.propTypes

/**
 * A wrapper for Google's Static Maps
 *
 * @see https://developers.google.com/maps/documentation/staticmaps/intro#Overview
 *
 * @example: http://staticmapmaker.com/google/
 */
class GoogleStaticMap extends Component<{ size?: any; mapType?: any; polyline: any }> {
    /**
     * https://developers.google.com/maps/documentation/staticmaps/intro#api_key
     */
    static RootUrl = 'https://maps.googleapis.com/maps/api/staticmap'

    static ImageFormats = IMAGE_FORMATS

    static MapTypes = MAP_TYPES

    static PathColor = '0x49b848ff'

    static PathWeight = '4'

    // static propTypes = {
    //     ...imagePropTypes,

    //     latitude: PropTypes.string,

    //     longitude: PropTypes.string,

    //     size: PropTypes.shape({
    //         width: PropTypes.number.isRequired,
    //         height: PropTypes.number.isRequired
    //     }),

    //     polyline: PropTypes.string,

    //     /**
    //      * zoom (required if markers not present) defines the zoom level of the map,
    //      * which determines the magnification level of the map.
    //      *
    //      * @see https://developers.google.com/maps/documentation/staticmaps/intro#Zoomlevels
    //      */
    //     zoom: PropTypes.number.isRequired,

    //     /**
    //      * scale affects the number of pixels that are returned.
    //      * scale=2 returns twice as many pixels as scale=1 while retaining the same coverage area and level of detail
    //      * The default value is calculated from the screen PixelRatio.
    //      */
    //     scale: PropTypes.number,

    //     /**
    //      * @see https://developers.google.com/maps/documentation/staticmaps/intro#ImageFormats
    //      */
    //     format: PropTypes.oneOf(IMAGE_FORMATS_VALUES),

    //     /**
    //      * @see https://developers.google.com/maps/documentation/staticmaps/intro#MapTypes
    //      */
    //     mapType: PropTypes.oneOf(MAP_TYPES_VALUES),

    //     /**
    //      * Add a marker on the center
    //      */
    //     hasCenterMarker: PropTypes.bool,

    //     apiKey: PropTypes.string
    // }

    static defaultProps = {
        scale: defaultMapScale(),
        format: IMAGE_FORMATS.PNG,
        mapType: MAP_TYPES.ROADMAP,
        hasCenterMarker: true,
        size: {
            width: 1920,
            height: 900
        }
    }

    render() {
        return (
            <img className="rounded-md shadow-lg" src={this.staticMapUrl}>
                {this.props.children}
            </img>
        )
    }

    get staticMapUrl() {
        const { size, mapType, polyline } = this.props

        const { width, height } = size
        const rootUrl = 'https://maps.googleapis.com/maps/api/staticmap'
        const pathColor = '0x49b848ff'
        const pathWeight = '4'

        return (
            `${rootUrl}?&size=${width}x${height}&maptype=${mapType}&` +
            `path=color:${pathColor}|weight:${pathWeight}|enc:${polyline}&${this.apiKeyParam}`
        )
    }

    get apiKeyParam() {
        return `key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}`
    }
}

export default GoogleStaticMap
